import React from 'react';
import styles from './index.module.scss';
import Lottie from 'lottie-react';
import loaderAnimationV2 from '../../assets/loaderV2.json';

function GlobalLoader() {
  return (
    <div
      className={styles.globalLoader}
      style={{
        minHeight: '100vh',
        background: '#000000bd',
        borderRadius: '0',
      }}
    >
      <Lottie
        animationData={loaderAnimationV2}
        loop={true}
        style={{
          width: 100,
        }}
      />
    </div>
  );
}

export default GlobalLoader;
